import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest, putRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import ConsultantForm from '../Registration/ConsultantForm';
import InterestDetails from '../ConsultantInterest/InterestDetails';
import './ConsultantCreateConsultantInterest.scss';
var EMPTY_ADDED_TAGS = {
  area_of_expertises: [],
  therapeutic_areas: [],
  therapies: [],
  development_phases: [],
  regulatory_pathways: [],
  disease_codes: [],
  accreditations: []
};
var ConsultantCreateConsultantInterest = /*#__PURE__*/function (_Component) {
  function ConsultantCreateConsultantInterest(props) {
    var _this;
    _classCallCheck(this, ConsultantCreateConsultantInterest);
    _this = _callSuper(this, ConsultantCreateConsultantInterest, [props]);
    _this.tagTypes = {
      area_of_expertises: 'Functional areas',
      therapeutic_areas: 'Therapeutic areas',
      therapies: 'Therapies',
      development_phases: 'Development phases',
      regulatory_pathways: 'Regulatory pathways',
      disease_codes: 'Disease codes',
      accreditations: 'Certification'
    };
    var checkboxes = {
      availability: null
    };
    if (props.project.employment_type === 'consulting') {
      checkboxes.tax_reporting = null;
    } else if (props.project.us_work_authorization_required) {
      checkboxes.work_authorization = null;
    }
    _this.state = {
      submitAttempted: false,
      disabled: true,
      resume: props.resume,
      checkboxes: checkboxes,
      requestedHourlyRate: props.consultantInterest ? props.consultantInterest.response.requested_hourly_rate : '',
      location: props.consultantInterest ? props.consultantInterest.response.location : '',
      modalOpen: props.modalOpen,
      openToRelocation: props.consultantInterest ? props.consultantInterest.response.open_to_relocation : false,
      locallyAddedTagIds: _objectSpread({}, EMPTY_ADDED_TAGS),
      addingTagsSaving: false,
      addingTagsError: null
    };
    _this.missingRequiredFields = _this.missingRequiredFields.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleToggleCheckbox = _this.handleToggleCheckbox.bind(_this);
    _this.handleTextChange = _this.handleTextChange.bind(_this);
    _this.handleUpdateResume = _this.handleUpdateResume.bind(_this);
    _this.handleWithdrawApplication = _this.handleWithdrawApplication.bind(_this);
    _this.isHybridOrInOffice = _this.isHybridOrInOffice.bind(_this);
    _this.handleOpenToggleCheckbox = _this.handleOpenToggleCheckbox.bind(_this);
    _this.handleAddExpertiseTags = _this.handleAddExpertiseTags.bind(_this);
    return _this;
  }
  _inherits(ConsultantCreateConsultantInterest, _Component);
  return _createClass(ConsultantCreateConsultantInterest, [{
    key: "missingRequiredFields",
    value: function missingRequiredFields() {
      var _this$props = this.props,
        project = _this$props.project,
        consultantInterest = _this$props.consultantInterest;
      var _this$state = this.state,
        resume = _this$state.resume,
        checkboxes = _this$state.checkboxes,
        requestedHourlyRate = _this$state.requestedHourlyRate,
        location = _this$state.location;
      if (consultantInterest) return false;
      var isHybridOrInOffice = this.isHybridOrInOffice();
      var areRequiredCheckboxesChecked = Object.entries(checkboxes).every(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return value;
      });
      var isHourlyRateValid = project.employment_type === 'full_time' || /^[0-9]+$/.test(requestedHourlyRate);
      var isLocationValid = isHybridOrInOffice ? location && location !== '' : true;
      return !(resume && areRequiredCheckboxesChecked && isHourlyRateValid && !this.missingRequiredExpertise() && isLocationValid);
    }
  }, {
    key: "handleToggleCheckbox",
    value: function handleToggleCheckbox(idx) {
      var _this2 = this;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'toggle';
      return function () {
        var checkboxes = _this2.state.checkboxes;
        var newValue = _objectSpread({}, checkboxes);
        if (value === 'toggle') {
          newValue[idx] = !newValue[idx];
        } else {
          newValue[idx] = value;
        }
        _this2.setState({
          checkboxes: newValue
        });
      };
    }
  }, {
    key: "handleOpenToggleCheckbox",
    value: function handleOpenToggleCheckbox() {
      var openToRelocation = this.state.openToRelocation;
      this.setState({
        openToRelocation: !openToRelocation
      });
    }
  }, {
    key: "isHybridOrInOffice",
    value: function isHybridOrInOffice() {
      var _project$office_and_w;
      var project = this.props.project;
      var info = (project === null || project === void 0 ? void 0 : (_project$office_and_w = project.office_and_worktype_information) === null || _project$office_and_w === void 0 ? void 0 : _project$office_and_w.toLowerCase()) || '';
      return info.includes('hybrid') || info.includes('in office') || info.includes('onsite');
    }
  }, {
    key: "handleTextChange",
    value: function handleTextChange(field) {
      var _this3 = this;
      return function (e) {
        if (field === 'requestedHourlyRate') {
          _this3.setState({
            requestedHourlyRate: e.target.value
          });
        } else if (field === 'location') {
          _this3.setState({
            location: e
          });
        }
      };
    }
  }, {
    key: "handleUpdateResume",
    value: function handleUpdateResume(resume) {
      analyticsTrack('Added/Updated Resume', {
        location: 'Consultant Interest'
      });
      this.setState({
        resume: resume.resume || resume
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props2 = this.props,
        formUrl = _this$props2.formUrl,
        project = _this$props2.project,
        csrfToken = _this$props2.csrfToken,
        consultantInterest = _this$props2.consultantInterest;
      var _this$state2 = this.state,
        resume = _this$state2.resume,
        requestedHourlyRate = _this$state2.requestedHourlyRate,
        openToRelocation = _this$state2.openToRelocation,
        location = _this$state2.location;
      var params = {
        consultant_interest: {
          project_id: project.id,
          resume_id: resume && resume.id,
          response: {
            requested_hourly_rate: requestedHourlyRate,
            open_to_relocation: openToRelocation,
            location: location
          }
        },
        authenticity_token: csrfToken,
        resource_id: project.resource_id
      };
      if (this.missingRequiredFields()) {
        this.setState({
          submitAttempted: true
        });
      } else if (consultantInterest) {
        putRequest("".concat(formUrl, "/").concat(consultantInterest.id), params);
      } else {
        postRequest(formUrl, params).then(function () {
          window.location.href = "/projects/".concat(project.resource_id, "/?interest_submitted=true");
        });
      }
    }
  }, {
    key: "handleWithdrawApplication",
    value: function handleWithdrawApplication() {
      var _this4 = this;
      var _this$props3 = this.props,
        withdrawPath = _this$props3.withdrawPath,
        csrfToken = _this$props3.csrfToken,
        project = _this$props3.project;
      putRequest(withdrawPath, {}, csrfToken).then(function () {
        _this4.setState({
          showModal: false
        });
        window.location.href = "/projects/".concat(project.resource_id);
      });
    }
  }, {
    key: "missingRequiredExpertise",
    value: function missingRequiredExpertise() {
      var project = this.props.project;
      var locallyAddedTagIds = this.state.locallyAddedTagIds;
      return Object.keys(this.tagTypes).reduce(function (agg, type) {
        var missing = (project.missing_priority_tags[type] || []).filter(function (tag) {
          return !locallyAddedTagIds[type].includes(tag.id);
        });
        return agg.concat(missing);
      }, []).length > 0;
    }
  }, {
    key: "handleAddExpertiseTags",
    value: function handleAddExpertiseTags(tagsByType) {
      var _this5 = this;
      var _this$props4 = this.props,
        addExpertiseTagsUrl = _this$props4.addExpertiseTagsUrl,
        csrfToken = _this$props4.csrfToken;
      if (!addExpertiseTagsUrl) return;
      this.setState({
        addingTagsSaving: true,
        addingTagsError: null
      });
      var body = {};
      Object.keys(tagsByType).forEach(function (type) {
        if (tagsByType[type].length > 0) body[type] = tagsByType[type];
      });
      postRequest(addExpertiseTagsUrl, body, csrfToken).then(function () {
        _this5.setState(function (prevState) {
          var updated = _objectSpread({}, prevState.locallyAddedTagIds);
          Object.keys(tagsByType).forEach(function (type) {
            var existing = updated[type] || [];
            var incoming = tagsByType[type];
            updated[type] = _toConsumableArray(new Set([].concat(_toConsumableArray(existing), _toConsumableArray(incoming))));
          });
          return {
            locallyAddedTagIds: updated,
            addingTagsSaving: false
          };
        });
      })["catch"](function () {
        _this5.setState({
          addingTagsSaving: false,
          addingTagsError: 'Failed to save tags. Please try again.'
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        project = _this$props5.project,
        consultantInterest = _this$props5.consultantInterest,
        uploadResumeUrl = _this$props5.uploadResumeUrl,
        csrfToken = _this$props5.csrfToken,
        formUrl = _this$props5.formUrl,
        sourced = _this$props5.sourced,
        modalOpen = _this$props5.modalOpen,
        profilePath = _this$props5.profilePath,
        invitedEmail = _this$props5.invitedEmail,
        signInUrl = _this$props5.signInUrl,
        googleOmniauthUrl = _this$props5.googleOmniauthUrl,
        msOmniauthUrl = _this$props5.msOmniauthUrl,
        referralToken = _this$props5.referralToken,
        otherOpportunities = _this$props5.otherOpportunities,
        showWithdrawButton = _this$props5.showWithdrawButton;
      var _this$state3 = this.state,
        resume = _this$state3.resume,
        submitAttempted = _this$state3.submitAttempted,
        checkboxes = _this$state3.checkboxes,
        requestedHourlyRate = _this$state3.requestedHourlyRate,
        location = _this$state3.location,
        openToRelocation = _this$state3.openToRelocation,
        locallyAddedTagIds = _this$state3.locallyAddedTagIds,
        addingTagsSaving = _this$state3.addingTagsSaving,
        addingTagsError = _this$state3.addingTagsError;
      return /*#__PURE__*/React.createElement("div", {
        className: "consultant-interest-application"
      }, /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: consultantInterest ? 'View Application' : 'Start Application',
        buttonStyles: consultantInterest ? 'body-text-2 demibold pl-0' : 'btn btn-primary bigger-button full-width',
        cancelButtonText: consultantInterest ? 'Close' : 'Finish Later',
        submitButtonText: consultantInterest ? 'Update application' : 'Submit application',
        handleSubmit: this.handleSubmit,
        triggerType: consultantInterest ? 'link' : 'button',
        idKey: profilePath ? 'consultant-interest-application' : 'consultant-registration-modal',
        cancelButton: true,
        showFooter: !!profilePath,
        closeAfterSubmit: !this.missingRequiredFields(),
        showModal: modalOpen,
        showWithdrawButton: showWithdrawButton,
        handleWithdrawApplication: this.handleWithdrawApplication,
        modalSize: profilePath ? 'lg' : 'md'
      }, profilePath ? /*#__PURE__*/React.createElement(InterestDetails, {
        project: project,
        uploadResumeUrl: uploadResumeUrl,
        profilePath: profilePath,
        csrfToken: csrfToken,
        resume: resume,
        formUrl: formUrl,
        missingRequiredFields: this.missingRequiredFields(),
        missingRequiredExpertise: this.missingRequiredExpertise(),
        handleToggleCheckbox: this.handleToggleCheckbox,
        handleTextChange: this.handleTextChange,
        handleUpdateResume: this.handleUpdateResume,
        requestedHourlyRate: requestedHourlyRate,
        location: location,
        submitAttempted: submitAttempted,
        checkboxes: checkboxes,
        submitted: consultantInterest !== null,
        isHybridOrInOffice: this.isHybridOrInOffice(),
        openToRelocation: openToRelocation,
        handleOpenToggleCheckbox: this.handleOpenToggleCheckbox,
        locallyAddedTagIds: locallyAddedTagIds,
        handleAddExpertiseTags: this.handleAddExpertiseTags,
        addingTagsSaving: addingTagsSaving,
        addingTagsError: addingTagsError
      }) : /*#__PURE__*/React.createElement("div", {
        className: "style-guide consultant-registration-modal registration form p-2 p-md-4 shadow-none"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header"
      }, "Stop Searching, Start Working"), /*#__PURE__*/React.createElement(ConsultantForm, {
        csrfToken: csrfToken,
        invitedEmail: invitedEmail,
        signInUrl: signInUrl,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        projectResourceId: project.resource_id,
        referralToken: referralToken,
        sourced: sourced,
        postOnboardUrl: otherOpportunities ? '/opportunities' : null
      }))));
    }
  }]);
}(Component);
ConsultantCreateConsultantInterest.propTypes = {
  formUrl: PropTypes.string.isRequired,
  project: PropTypes.shape({
    id: PropTypes.number,
    us_work_authorization_required: PropTypes.bool,
    employment_type: PropTypes.string
  }).isRequired,
  consultantInterest: PropTypes.shape({
    response: PropTypes.shape({
      requested_hourly_rate: PropTypes.string
    })
  }),
  resume: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string.isRequired,
  profilePath: PropTypes.string.isRequired,
  addExpertiseTagsUrl: PropTypes.string,
  signInUrl: PropTypes.string,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  invitedEmail: PropTypes.string,
  referralToken: PropTypes.string,
  sourced: PropTypes.string,
  modalOpen: PropTypes.bool,
  otherOpportunities: PropTypes.bool,
  showWithdrawButton: PropTypes.bool,
  withdrawPath: PropTypes.string
};
ConsultantCreateConsultantInterest.defaultProps = {
  consultantInterest: null,
  resume: null,
  addExpertiseTagsUrl: null,
  invitedEmail: null,
  referralToken: null,
  signInUrl: null,
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  sourced: null,
  modalOpen: false,
  otherOpportunities: false,
  showWithdrawButton: false,
  withdrawPath: null
};
export default ConsultantCreateConsultantInterest;